/* GASSISA
=========================================================================================
* Descripción: 
* Historial de cambios:
* ---------------------------------------------------------------------------------------
*    Revisión   | Fecha      | Desarrollador                    | Resumen del cambio
* ---------------------------------------------------------------------------------------
*      1       | 8/11/2024 | Lic. José Luis Aragón Cervantes  | Creación
*      2       | 15/04/2026 |                               | Navegación mejorada con recarga servidor
*      3       | 31/05/2026 | Lic. José Luis Aragón Cervantes  | Apertura de modal sin animación
*      4       | 31/05/2026 | Lic. José Luis Aragón Cervantes  | Limpieza de evento de talla registrado
*      5       | 31/05/2026 | Lic. José Luis Aragón Cervantes  | Normalización y limpieza de medidas por artículo
*      6       | 31/05/2026 | Lic. José Luis Aragón Cervantes  | Carga de medidas desde consulta de existencias
*      7       | 31/05/2026 | Lic. José Luis Aragón Cervantes  | Control de registro pendiente al cerrar modal
*      8       | 31/05/2026 | Lic. José Luis Aragón Cervantes  | Protección anti doble registro
*      9       | 31/05/2026 | Lic. José Luis Aragón Cervantes  | Retiro de conector fijo de medidas
*      10      | 31/05/2026 | Lic. José Luis Aragón Cervantes  | Registro con Enter desde modal sin mover foco
*      11      | 31/05/2026 | Lic. José Luis Aragón Cervantes  | Consulta de existencias multi almacén
*      12      | 31/05/2026 | Lic. José Luis Aragón Cervantes  | Modo multi almacén configurable
*      13      | 31/05/2026 | Lic. José Luis Aragón Cervantes  | Visual de medidas completas por artículo
*      14      | 31/05/2026 | Lic. José Luis Aragón Cervantes  | Centrado y scroll horizontal de medidas
*      15      | 31/05/2026 | Lic. José Luis Aragón Cervantes  | Foco a lista al cambiar almacén
*      16      | 01/06/2026 | Lic. José Luis Aragón Cervantes  | Sin alerta al elegir medida sin existencia
*      17      | 01/06/2026 | Lic. José Luis Aragón Cervantes  | Registro delegado al flujo padre sin validar existencia en modal
*      18      | 02/06/2026 | Lic. José Luis Aragón Cervantes  | Selección repetible de filtro con Alt+F1
*      19      | 26/06/2026 | Lic. Jose Luis Aragon Cervantes  | Distribucion responsiva independiente para portatil
*      20      | 26/06/2026 | Lic. Jose Luis Aragon Cervantes  | Tecla Enter visible en filtro para teclado movil
*      21      | 10/10/2026 | Lic. José Luis Aragón C.  | Push-to-talk: el micrófono se escucha mientras se mantiene presionado y entrega el texto al soltar
* --------------------------------------------------------------------------------------- 
*/

import TextField from "../../ui/TextField";
import React, { Fragment, useState, useEffect, useRef, useMemo } from "react";
import { MenuItem, Button, IconButton, Tooltip } from "@mui/material";
import { apiFiltroExistenciasAlmacenExhibidor, apiBuscarArticuloPorCodigoBarras } from "../../../settings/ApiConfig";

import UpdateIcon from '@mui/icons-material/Update';
import ContentCopy from '@mui/icons-material/ContentCopy';
import CloseIcon from '@mui/icons-material/Close';

import { useLayout } from "../../../context/System/LayoutContext";
import { useRequest } from "../../../context/System/RequestContext";
import { useInventarios } from "../../../context/Inventarios/InventariosContext";
import SizeSoftXMedidasExistencias from "../../leyout/SizeSoftXMedidasExistencias";
import FrmLoginValidate from "../../administracion/FrmLoginValidate";

import { useSesion } from "../../../context/System/SesionContext";
import SizeSoftXModalPortatil from "../leyout/SizeSoftXModalPortatil";
import useSpeechToText from "../../leyout/useSpeechToText";
import BotonVoz from "../../leyout/BotonVoz";
import { copiarTexto } from "../../../helpers/portapapeles";

const tallasData = [{ talla: 0, cantidad: 0 }];
const normalizarAlmacen = (value) => (value || "").trim().toUpperCase();

const FILTRO_INPUT_PROPS = { maxLength: 50, minLength: 3 };
const FILTRO_SX = { width: '100%' };
const ALMACEN_SX = { width: '100%' };

export default function ModalBuscarArticulosParaVenta(props) {
    const { openModal, handleCloseModal, dominio, onTallaSelect, articuloSelect, consultarTodosAlmacenes = false, skipFullData = false } = props;

    const filtroRef = useRef(null);
    const medidasRef = useRef(null);
    const almacenRef = useRef(null);
    const tablaRef = useRef(null);
    const modalOpenRef = useRef(openModal);
    const registroEnProcesoRef = useRef(false);
    const ultimoRegistroRef = useRef({ key: "", time: 0 });

    const { handleDarIngresoRapido } = useInventarios();
    const { parametrosCajaForm } = useSesion();

    const { GetRequest, PostRequest } = useRequest();
    const { handleOpenAlert } = useLayout();

    const { isSupported, hasPermission, isListening, error: speechError, startListening, stopListening, checkPermission } = useSpeechToText({
        onResult: (text) => {
            const cleaned = text.replace(/[.]+$/, '').trim();
            setDataFiltro(cleaned);
            setStatusValidation(false);
            HandleBuscarArticulos(normalizeFilter(cleaned));
            setTimeout(() => filtroRef.current?.dispatchEvent(new KeyboardEvent('keydown', { key: 'Enter', bubbles: true })), 100);
        }
    });

    const [listaArticulosFiltro, setListaArticulosFiltro] = useState([]);
    const [articuloSeleccionado, setArticuloSeleccionado] = useState({});
    const [dataFiltro, setDataFiltro] = useState("--");
    
    const [almacenSeleccionado, setAlmacenSeleccionado] = useState("");
    const [listaAlmacenes, setListaAlmacenes] = useState([]);
    const [listaTallasAlmacen, setListaTallasAlmacen] = useState(tallasData);
    const [listaTallasGeneral, setListaTallasGeneral] = useState([]);
    const [tallaSeleccionada, setTallaSeleccionada] = useState("");

    useEffect(() => {
        if (dominio && !almacenSeleccionado) {
            setAlmacenSeleccionado(normalizarAlmacen(dominio));
        }
    }, [dominio]);
    
    const [openModalLoginPermiso, setOpenModalLoginPermiso] = useState(false);
    const [statusValidation, setStatusValidation] = useState(false);

    const [ingresoRapidoLoading, setIngresoRapidoLoading] = useState(false);

    const [eventLeftRightEnter, setEventLeftRightEnter] = useState({ key: null, tick: null });

    const limpiarEventoMedidas = () => {
        setEventLeftRightEnter({ key: null, tick: null });
    };

    const limpiarEstadoRegistro = () => {
        setTallaSeleccionada("");
        limpiarEventoMedidas();
    };

    const esRegistroDuplicado = (key) => {
        const ahora = Date.now();
        const ultimo = ultimoRegistroRef.current;
        const duplicado = ultimo.key === key && (ahora - ultimo.time) < 1200;

        if (!duplicado) {
            ultimoRegistroRef.current = { key, time: ahora };
        }

        return duplicado;
    };

    const handleInicializarEstados = (resetFiltro = false) => {
        setListaArticulosFiltro([]);
        setArticuloSeleccionado({});
        setAlmacenSeleccionado("");
        setListaAlmacenes([]);
        setListaTallasAlmacen(tallasData);
        setListaTallasGeneral([]);
        if (resetFiltro) setDataFiltro("--");
        setStatusValidation(false);
        limpiarEstadoRegistro();
    };

    const limpiarMedidasArticulo = () => {
        setListaAlmacenes([]);
        setListaTallasGeneral([]);
        setListaTallasAlmacen([]);
        limpiarEstadoRegistro();
    };

    const enfocarFiltro = () => {
        setTimeout(() => {
            if (filtroRef.current) {
                filtroRef.current.focus();
                filtroRef.current.select();
            }
        }, 0);
    };

    const handleFocusSelect = (e) => e.target.select();

    const handleChangeFilter = (e) => {
        setDataFiltro(e.target.value);
        setStatusValidation(false);
    };

    // Normalizar filtro: trim, mayúsculas y reemplazar '/' por espacio (igual que backend)
    const normalizeFilter = (value) => {
        if (!value) return "";
        return value.trim().toUpperCase().replace(/\//g, ' ');
    };

    // Normalizar clave de artículo: trim y mayúsculas
    const normalizeClaveArticulo = (clave) => {
        if (!clave) return "";
        return clave.trim().toUpperCase();
    };

    const normalizarArticuloExistencias = (articulo) => ({
        ...articulo,
        clavearticulo: articulo.clavearticulo ?? articulo.sClaveArticulo ?? "",
        descripcion: articulo.descripcion ?? articulo.sDescripcion ?? "",
        listamedidas: articulo.listamedidas ?? articulo.lMedidas ?? [],
    });

    const normalizarMedidaExistencia = (medida, articulo, almacen) => ({
        talla: medida.medida ?? medida.sMedida ?? 0,
        cantidad: medida.existencia ?? medida.dExistencia ?? 0,
        codigobarras: medida.codigobarras ?? medida.sCodigoBarras ?? "",
        almacenexhibidor: normalizarAlmacen(medida.almacenexhibidor ?? almacen),
        clavearticulo: normalizeClaveArticulo(articulo?.clavearticulo),
        manejamedida: medida.manejamedida ?? medida.bManejaMedida ?? true,
    });

    const obtenerCodigoCopiable = (articulo) => (
        (articulo?.listamedidas ?? articulo?.lMedidas ?? [])
            .map((m) => m.codigobarras ?? m.sCodigoBarras)
            .find(Boolean) ?? (articulo?.clavearticulo ?? articulo?.sClaveArticulo ?? "")
    );

    const cargarMedidasDesdeArticulo = async (articulo, articulosBase = listaArticulosFiltro) => {
        if (!articulo) return;

        const almacenPreferido = normalizarAlmacen(dominio || almacenSeleccionado);
        const medidas = (articulo.listamedidas ?? []).map((medida) =>
            normalizarMedidaExistencia(medida, articulo, almacenPreferido)
        );
        const almacenes = [...new Set(medidas
            .map((medida) => normalizarAlmacen(medida.almacenexhibidor))
            .filter(Boolean))];
        const almacenDefault = almacenes.includes(almacenPreferido)
            ? almacenPreferido
            : (almacenes[0] || almacenPreferido);

        setListaAlmacenes(almacenes);
        setAlmacenSeleccionado(almacenDefault);
        setListaTallasGeneral(medidas);
        await subCargarTallas(almacenDefault, medidas, articulosBase);
        return medidas;
    };

    // Buscar artículos con sus medidas y existencias desde una sola consulta
    const HandleBuscarArticulos = async (filtro) => {
        const almacen = consultarTodosAlmacenes
            ? "TODOS"
            : normalizarAlmacen(dominio || almacenSeleccionado);

        if (!almacen) {
            handleOpenAlert("Seleccione un almacén/exhibidor para consultar existencias");
            return [];
        }

        const response = await PostRequest({
            url: apiFiltroExistenciasAlmacenExhibidor,
            body: {
                filtro,
                almacenexhibidor: almacen,
            },
            loader: "Buscando artículos con existencias",
        });

        if (response.hasError) {
            handleOpenAlert(response.message);
            return [];
        }

        const lista = (response.result ?? []).map(normalizarArticuloExistencias);

        setListaArticulosFiltro(lista);
        
        if (lista.length > 0) {
            setArticuloSeleccionado(lista[0]);
            await cargarMedidasDesdeArticulo(lista[0], lista);
        }
        return lista;
    };

    const handleOnKeyDowsFilter = async (e) => {
        try {
            if (e.key === 'Enter') {
                const normalized = normalizeFilter(dataFiltro);
                if (normalized.length === 0) {
                    setListaArticulosFiltro([]);
                    return;
                }

                await HandleBuscarArticulos(normalized);
                tablaRef.current?.focus();
                return;
            }
            else if (e.key === 'ArrowDown') {
                if (listaArticulosFiltro.length === 0) return;
                tablaRef.current?.focus();
                setEventLeftRightEnter({ key: null, tick: null });
                setArticuloSeleccionado(listaArticulosFiltro[0]);
                await cargarMedidasDesdeArticulo(listaArticulosFiltro[0]);
            }
        }
        catch {
            return;
        }
    };

    const handleBuscarArticuloFullData = async (e) => {
        const response = await GetRequest({
            url: apiBuscarArticuloPorCodigoBarras.replace("{codigobarras}", e),
            alert: "Buscando artículo por código de barras"
        });

        if (response.hasError) {
            return;
        }
        return response?.result;
    };

    const handleChangePartidaSeleccionada = (e) => {
        if (e === null || e === undefined) return;
        setArticuloSeleccionado(e);
        limpiarMedidasArticulo();
        cargarMedidasDesdeArticulo(e);
        const talla = e.listamedidas?.[0]?.medida ?? e.listamedidas?.[0]?.sMedida ?? e.listamedidas?.[0]?.talla;
        if (talla != null) {
            setTallaSeleccionada(talla);
        }
    };

    const subCargarTallas = async (almacenExhibidor, listaGeneral = [], articulosBase = listaArticulosFiltro) => {
        if (!almacenExhibidor || !listaGeneral) return;

        const almacenNormalizado = normalizarAlmacen(almacenExhibidor);
        const tallasResultado = [...new Set(
            (articulosBase ?? [])
                .flatMap((articulo) => articulo.listamedidas ?? [])
                .map((medida) => Number(medida.medida ?? medida.sMedida ?? medida.talla))
                .filter((medida) => !Number.isNaN(medida) && medida > 0)
        )].sort((a, b) => a - b);

        const medidasArticulo = listaGeneral
            .filter(a => normalizarAlmacen(a.almacenexhibidor) === almacenNormalizado)
            .map(a => ({
                talla: a.talla ?? a.medida,
                cantidad: a.cantidad ?? a.existencia,
                codigobarras: a.codigobarras,
                almacenexhibidor: normalizarAlmacen(a.almacenexhibidor),
                clavearticulo: normalizeClaveArticulo(a.clavearticulo),
                manejamedida: a.manejamedida ?? true,
            }));

        const tallasBase = tallasResultado.length > 0
            ? tallasResultado
            : medidasArticulo.map((medida) => Number(medida.talla)).sort((a, b) => a - b);

        const tallas = tallasBase.map((talla) => {
            const registro = medidasArticulo.find((medida) => Number(medida.talla) === Number(talla));
            return registro ?? {
                talla,
                cantidad: null,
                codigobarras: "",
                almacenexhibidor: almacenNormalizado,
                clavearticulo: normalizeClaveArticulo(articuloSeleccionado?.clavearticulo),
                manejamedida: false,
            };
        });

        setListaTallasAlmacen(tallas ?? []);
    };

    const handleChangeAlmacen = async (e) => {
        const almacen = normalizarAlmacen(e.target.value);
        setAlmacenSeleccionado(almacen);
        await subCargarTallas(almacen, listaTallasGeneral);
        setTimeout(() => {
            tablaRef.current?.focus();
        }, 0);
    };

    const handleRegistrarArticuloVenta = async (e) => {
        if (registroEnProcesoRef.current) return;

        let Talla = e.talla;
        setTallaSeleccionada(Talla);
        if (!almacenSeleccionado || !articuloSeleccionado) return;
        if (!Talla) return;
        if (e.manejamedida === false) {
            handleOpenAlert("El artículo no maneja la medida seleccionada");
            return;
        }
        const almacenNormalizado = normalizarAlmacen(almacenSeleccionado);
        const claveNormalizada = normalizeClaveArticulo(articuloSeleccionado.clavearticulo);
        const registroKey = `${claveNormalizada}|${almacenNormalizado}|${Number(Talla)}`;

        if (esRegistroDuplicado(registroKey)) {
            return;
        }

        const codigo = listaTallasGeneral
            .find(a =>
                normalizarAlmacen(a.almacenexhibidor) === almacenNormalizado
                && normalizeClaveArticulo(a.clavearticulo) === claveNormalizada
                && Number(a.talla ?? a.medida) === Number(Talla)
            )?.codigobarras;

        if (!codigo) {
            handleOpenAlert("No se encontró código de barras para la talla seleccionada");
            return;
        }
        
        registroEnProcesoRef.current = true;
        limpiarEstadoRegistro();
        onTallaSelect(Talla);

        try {
            if (skipFullData) {
                const dataMin = { codigobarras: codigo };
                setArticuloSeleccionado(dataMin);
                articuloSelect(dataMin, almacenSeleccionado);
                handleCloseModal();
                return;
            }

            const dataFull = await handleBuscarArticuloFullData(codigo);

            if (!modalOpenRef.current || !dataFull) {
                return;
            }

            const medidaInfo = listaTallasGeneral.find(a =>
                normalizarAlmacen(a.almacenexhibidor) === almacenNormalizado &&
                normalizeClaveArticulo(a.clavearticulo) === claveNormalizada &&
                Number(a.talla ?? a.medida) === Number(Talla)
            );
            dataFull.existencia = medidaInfo?.cantidad ?? 0;

            setArticuloSeleccionado(dataFull);
            articuloSelect(dataFull, almacenSeleccionado);
            handleCloseModal();
        } finally {
            registroEnProcesoRef.current = false;
            limpiarEstadoRegistro();
        }
    };

    // Función para hacer scroll al registro seleccionado
    const scrollToSelectedRow = () => {
        const container = tablaRef.current;
        if (!container) return;

        const selectedRow = container.querySelector('tr.selected');
        if (!selectedRow) return;

        const rowTop = selectedRow.offsetTop;
        const rowHeight = selectedRow.offsetHeight;
        const rowBottom = rowTop + rowHeight;

        const viewTop = container.scrollTop;
        const viewHeight = container.clientHeight;
        const viewBottom = viewTop + viewHeight;

        const padding = 8; // 🔥 espacio visual

        // 🔽 BAJANDO (corregido)
        if (rowBottom > viewBottom) {
            container.scrollTop = rowBottom - viewHeight + padding;
        }

        // 🔼 SUBIENDO (ya te funcionaba)
        else if (rowTop < viewTop) {
            container.scrollTop = rowTop - padding;
        }
    };
    
    // Navegación en tabla con flechas
    const handleKeyDownTabla = (e) => {
        if (!listaArticulosFiltro?.length) return;

        const index = listaArticulosFiltro.findIndex(
            item => item.clavearticulo === articuloSeleccionado?.clavearticulo
        );

        // 🔽 BAJAR
        if (e.key === "ArrowDown") {
            e.preventDefault();
            e.stopPropagation();

            const nextIndex = index === -1 ? 0 : index + 1;

            if (nextIndex < listaArticulosFiltro.length) {
                const next = listaArticulosFiltro[nextIndex];
                setArticuloSeleccionado(next);
                limpiarMedidasArticulo();
                cargarMedidasDesdeArticulo(next);
                setTimeout(scrollToSelectedRow, 10);
            }
            return;
        }

        // 🔼 SUBIR (incluye regreso al filtro en index 0)
        if (e.key === "ArrowUp") {
            e.preventDefault();
            e.stopPropagation();

            if (index > 0) {
                const prev = listaArticulosFiltro[index - 1];
                setArticuloSeleccionado(prev);
                limpiarMedidasArticulo();
                cargarMedidasDesdeArticulo(prev);
                setTimeout(scrollToSelectedRow, 10);
            } else {
                // liberar foco de la tabla y regresar al filtro
                tablaRef.current?.blur();

                setTimeout(() => {
                    if (filtroRef.current) {
                        filtroRef.current.focus();
                        filtroRef.current.select();
                    }
                }, 0);
            }
            return;
        }

        // âŽ ENTER → ir a medidas
        if (e.key === "Enter") {
            e.preventDefault();
            e.stopPropagation();

            setEventLeftRightEnter(prev => ({
                key: "Enter",
                tick: (prev.tick ?? 0) + 1
            }));
            return;
        }

        // ← →
        if (e.key === "ArrowLeft" || e.key === "ArrowRight") {
            e.preventDefault();
            e.stopPropagation();

            setEventLeftRightEnter(prev => ({
                key: e.key,
                tick: (prev.tick ?? 0) + 1
            }));
        }
    };

    const handleDoubleClickRow = (articulo) => {
        if (!articulo) return;
        setArticuloSeleccionado(articulo);
        limpiarMedidasArticulo();
        cargarMedidasDesdeArticulo(articulo);
    };

    const handleTallaSelect = (e) => {
        setTallaSeleccionada(e.talla);
    };

    useEffect(() => {
        if (!openModal) return;

        const handleEnterModal = (event) => {
            if (event.key !== "Enter") return;
            if (!articuloSeleccionado?.clavearticulo) return;

            const target = event.target;
            const targetName = target?.getAttribute?.("name");
            const targetTag = target?.tagName?.toUpperCase();
            const isInputTarget = ["INPUT", "TEXTAREA", "SELECT"].includes(targetTag);
            const isCombobox = target?.closest?.('[role="combobox"], [role="listbox"], .MuiPopover-root');

            if (targetName === "Filtro" || targetName === "almacenexhibidor" || isInputTarget || isCombobox) {
                return;
            }

            if (tallaSeleccionada == null) return;

            event.preventDefault();
            handleRegistrarArticuloVenta({ talla: tallaSeleccionada });
        };

        window.addEventListener("keydown", handleEnterModal);
        return () => {
            window.removeEventListener("keydown", handleEnterModal);
        };
    }, [openModal, articuloSeleccionado, tallaSeleccionada, listaTallasAlmacen, almacenSeleccionado, listaTallasGeneral]);

    const handleOpenLoginValidate = () => {
        setOpenModalLoginPermiso(true);
    };

    const handleCloseLoginValidate = () => {
        setOpenModalLoginPermiso(false);
    };

    const handleHabilitarHerramientaEspecial = () => {
        setStatusValidation(true);
    };

    const handleApiIngresoRapido = async () => {
        if (registroEnProcesoRef.current || ingresoRapidoLoading) return;

        if (!articuloSeleccionado || !articuloSeleccionado.clavearticulo) {
            handleOpenAlert("Por favor seleccione un artículo vélido");
            return;
        }
        
        if (!tallaSeleccionada) {
            handleOpenAlert("Por favor seleccione una talla/medida");
            return;
        }
        
        if (!almacenSeleccionado) {
            handleOpenAlert("Por favor seleccione un almacén");
            return;
        }

        setIngresoRapidoLoading(true);
        registroEnProcesoRef.current = true;

        try {
            const claveAnterior = normalizeClaveArticulo(articuloSeleccionado.clavearticulo);
            const almacenAnterior = almacenSeleccionado;
            const tallaAnterior = tallaSeleccionada;

            await handleDarIngresoRapido(
                articuloSeleccionado.clavearticulo.trim(), 
                tallaSeleccionada, 
                almacenSeleccionado, 
                parametrosCajaForm.caja.trim()
            );

            // Recargar el mismo filtro para ver existencias actualizadas
            const filtroActual = normalizeFilter(dataFiltro);
            if (filtroActual.length > 0) {
                const listaActualizada = await HandleBuscarArticulos(filtroActual);
                if (listaActualizada.length > 0) {
                    const mismoArticulo = listaActualizada.find(a =>
                        normalizeClaveArticulo(a.clavearticulo) === claveAnterior
                    );
                    if (mismoArticulo) {
                        setArticuloSeleccionado(mismoArticulo);
                        const medidasFresh = await cargarMedidasDesdeArticulo(mismoArticulo, listaActualizada);
                        if (medidasFresh) {
                            const almacenesActualizados = [...new Set(medidasFresh
                                .map(m => normalizarAlmacen(m.almacenexhibidor))
                                .filter(Boolean)
                            )];
                            if (almacenesActualizados.includes(almacenAnterior)) {
                                setAlmacenSeleccionado(almacenAnterior);
                                await subCargarTallas(almacenAnterior, medidasFresh, listaActualizada);
                            }
                        }
                    }
                }
            }

            setTallaSeleccionada(tallaAnterior);
            setStatusValidation(true);

            enfocarFiltro();
        } finally {
            registroEnProcesoRef.current = false;
            setIngresoRapidoLoading(false);
        }
    }

    useEffect(() => {
        modalOpenRef.current = openModal;

        if (openModal) {
            setArticuloSeleccionado({});
            setListaTallasAlmacen(tallasData);
            setListaTallasGeneral([]);
            setStatusValidation(false);
            limpiarEstadoRegistro();
            
            if (dominio) {
                setAlmacenSeleccionado(normalizarAlmacen(dominio));
            } else {
                setAlmacenSeleccionado("");
            }
            
            enfocarFiltro();
        } else {
            registroEnProcesoRef.current = false;
            ultimoRegistroRef.current = { key: "", time: 0 };
            limpiarEstadoRegistro();
        }
    }, [openModal, dominio]);

    useEffect(() => {
        if (!openModal) return;

        const handleFocusFiltroShortcut = (event) => {
            if (event.altKey && event.key.trim().toUpperCase() === 'F1') {
                event.preventDefault();
                event.stopPropagation();
                enfocarFiltro();
            }
        };

        window.addEventListener('keydown', handleFocusFiltroShortcut, true);
        return () => window.removeEventListener('keydown', handleFocusFiltroShortcut, true);
    }, [openModal]);

    useEffect(() => {
        if (openModal) checkPermission();
    }, [openModal, checkPermission]);

    return (
        <SizeSoftXModalPortatil
            open={openModal}
            onClose={handleCloseModal}
            className="modal-buscador-articulos-portatil"
            sx={{ width: 'min(94vw, 920px)', p: { xs: 1.25, sm: 2 } }}
        >
            <Fragment>
                <div className="bannerbuscadorarticulos buscador-articulos-portatil">
                    <div className="buscador-articulos-portatil__header">
                        <p className="titulobuscadorarticulos">Buscador de artículos con existencias</p>
                        <IconButton onClick={handleCloseModal} aria-label="Cerrar buscador">
                            <CloseIcon />
                        </IconButton>
                    </div>
                    <div className="filtrobuscadorarticulos">
                        <TextField autoComplete="off"
                            inputRef={filtroRef}
                            name="Filtro"
                            label="Filtro:"
                            value={dataFiltro}
                            onChange={handleChangeFilter}
                            onFocus={(e) => handleFocusSelect(e)}
                            onKeyDown={handleOnKeyDowsFilter}
                            type="text"
                            inputMode="text"
                            inputProps={FILTRO_INPUT_PROPS}
                            slotProps={{ htmlInput: { enterKeyHint: "enter" } }}
                            sx={FILTRO_SX}
                        />
                        <BotonVoz
                                isSupported={isSupported}
                                hasPermission={hasPermission}
                                isListening={isListening}
                                onStart={startListening} onStop={stopListening}
                            />
                    </div>
                    <div className="tablaarticulosfiltrados">
                        <div
                            ref={tablaRef}
                            tabIndex={0}
                            onKeyDown={handleKeyDownTabla}
                            style={{ outline: 'none', maxHeight: '180px', overflowY: 'auto' }}
                        >
                            <table 
                                style={{
                                    width: '100%',
                                    borderCollapse: 'collapse',
                                    tableLayout: 'fixed'
                                }}
                            >
                                <thead>
                                    <tr style={{ backgroundColor: '#f5f5f5' }}>
                                        <th style={{ width: '30%', padding: '8px', textAlign: 'left', borderBottom: '2px solid #ddd' }}>
                                        Descripción
                                        </th>
                                        <th style={{ width: '10%', padding: '8px', textAlign: 'left', borderBottom: '2px solid #ddd' }}>
                                        Material
                                        </th>
                                        <th style={{ width: '10%', padding: '8px', textAlign: 'left', borderBottom: '2px solid #ddd' }}>
                                        Fabricante
                                        </th>
                                        <th style={{ width: '15%', padding: '8px', textAlign: 'left', borderBottom: '2px solid #ddd' }}>
                                        Familia
                                        </th>
                                        <th style={{ width: '15%', padding: '8px', textAlign: 'left', borderBottom: '2px solid #ddd' }}>
                                        Subfamilia
                                        </th>
                                        <th style={{ width: '20%', padding: '8px', textAlign: 'left', borderBottom: '2px solid #ddd' }}>
                                        Clave artículo
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {listaArticulosFiltro.length > 0 ? (
                                        listaArticulosFiltro.map((articulo, i) => (
                                        <tr
                                            key={i}
                                            onClick={() => handleChangePartidaSeleccionada(articulo)}
                                            onDoubleClick={() => handleDoubleClickRow(articulo)}
                                            className={articuloSeleccionado?.clavearticulo === articulo.clavearticulo ? 'selected' : ''}
                                            style={{
                                            backgroundColor: articuloSeleccionado?.clavearticulo === articulo.clavearticulo ? '#e3f2fd' : 'white',
                                            cursor: 'pointer'
                                            }}
                                        >
                                            <td style={{ padding: '6px', borderBottom: '1px solid #eee', textAlign: 'left' }}>
                                            {articulo.descripcion}
                                            </td>
                                            <td style={{ padding: '6px', borderBottom: '1px solid #eee', textAlign: 'left' }}>
                                            {articulo.material}
                                            </td>
                                            <td style={{ padding: '6px', borderBottom: '1px solid #eee', textAlign: 'left' }}>
                                            {articulo.fabricante}
                                            </td>
                                            <td style={{ padding: '6px', borderBottom: '1px solid #eee', textAlign: 'left' }}>
                                            {articulo.familia}
                                            </td>
                                            <td style={{ padding: '6px', borderBottom: '1px solid #eee', textAlign: 'left' }}>
                                            {articulo.subfamilia}
                                            </td>
                                            <td style={{ padding: '6px', borderBottom: '1px solid #eee', textAlign: 'left' }}>
                                            {articulo.clavearticulo}
                                            <IconButton size="small" title="Copiar código de barras" aria-label="Copiar código de barras" sx={{ ml: 0.5, p: 0.25 }} onClick={(e) => { e.stopPropagation(); copiarTexto(obtenerCodigoCopiable(articulo)); }}>
                                                <ContentCopy fontSize="inherit" sx={{ fontSize: 14 }} />
                                            </IconButton>
                                            </td>
                                        </tr>
                                        ))
                                    ) : (
                                        <tr>
                                        <td colSpan={6} style={{ padding: '20px', textAlign: 'center', borderBottom: '1px solid #eee' }}>
                                            {!dataFiltro || dataFiltro === "--" ? "Escriba un filtro y presione Enter" : "No se encontraron artículos"}
                                        </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                            {listaArticulosFiltro.length > 0 && (
                                <div style={{ padding: '8px', textAlign: 'center', backgroundColor: '#f5f5f5', borderTop: '1px solid #ddd' }}>
                                    {listaArticulosFiltro.length} artículos encontrados
                                </div>
                            )}
                        </div>
                    </div>
                    {articuloSeleccionado.clavearticulo && (
                        <div className="detallesarticulosfiltrados">
                            <div>
                                <div className="alignmeddidas">
                                    <div>
                                        <TextField autoComplete="off"
                                            ref={almacenRef}
                                            name="almacenexhibidor"
                                            label="Almacén/Exhibidor:"
                                            value={listaAlmacenes.includes(almacenSeleccionado) ? almacenSeleccionado : ""}
                                            onChange={handleChangeAlmacen}
                                            sx={ALMACEN_SX}
                                            select
                                        >
                                            <MenuItem value="">--Seleccione un Almacén---</MenuItem>
                                            {listaAlmacenes.map((x) => (
                                                <MenuItem key={x} value={x}>{x}</MenuItem>
                                            ))}
                                        </TextField>
                                    </div>
                                </div>
                                <div className="btnloginvalidate medidas-scroll-container">
                                    <SizeSoftXMedidasExistencias
                                        ref={medidasRef}
                                        tallas={listaTallasAlmacen}
                                        onKeyDown={handleRegistrarArticuloVenta}
                                        tallaSelect={handleTallaSelect}
                                        hadleEventKeySender={eventLeftRightEnter}
                                        onCommandConsumed={limpiarEventoMedidas}
                                    />
                                </div>
                            </div>
                            <div className="btnloginvalidate">
                                <Tooltip className="botonesmedidas" title="Permitir ingreso répido">
                                    <IconButton
                                        onClick={handleOpenLoginValidate}
                                        sx={{
                                            border: "2px solid #23165dff",
                                            boxShadow: "0 4px 10px rgba(0,0,0,0.3)",
                                            transition: "all 0.2s ease-in-out",
                                            backgroundColor: "#fff",
                                            "&:hover": {
                                                backgroundColor: "#e3f2fd",
                                                transform: "scale(1.1)",
                                                boxShadow: "0 6px 14px rgba(0,0,0,0.4)",
                                            },
                                            "&:active": {
                                                transform: "scale(0.95)",
                                            }
                                        }}
                                    >
                                        <UpdateIcon color="primary" />
                                    </IconButton>
                                </Tooltip>
                                {statusValidation && (
                                    <div className="ingresosrapidosframe">
                                        <Button
                                            onClick={handleApiIngresoRapido}
                                            disabled={ingresoRapidoLoading}
                                            style={{
                                                backgroundColor: ingresoRapidoLoading ? "#ccc" : "#a9701e",
                                                color: "#FFFFFF"
                                            }}
                                        >
                                            {ingresoRapidoLoading ? "Procesando..." : "Ingreso répido"}
                                        </Button>
                                    </div>
                                )}
                            </div>
                        </div>
                    )}
                </div>
                <FrmLoginValidate
                    openModal={openModalLoginPermiso}
                    tiposUsuario={["SA", "ADMINISTRADOR", "SUPERVISOR"]}
                    handleComandoEjecucion={handleHabilitarHerramientaEspecial}
                    hancleCloseModalValidator={() => handleCloseLoginValidate()}
                />
            </Fragment>
        </SizeSoftXModalPortatil>
    );
}
